import { Box, Typography, Divider, Chip } from '@mui/material';

function Summary({ summary, aspirations }) {
    return (
        <Box sx={{ mx: 2 }}> 
            <Typography variant="h5" sx={{ color: '#666', mb: 2 }}>Profile Summary</Typography>
            <Typography variant="body1" sx={{ color: '#888' }}>{summary}</Typography>
            <Typography variant="subtitle1" sx={{ color: '#888', mt: 2 }} ><b>Aspirations:</b> {aspirations}</Typography>
        <Divider sx={{ mb: 2, mt: 2 }} />
    </Box> 
    )
}

export default Summary;